import { controls, currencyToNumber, grouped } from "../../controls";

const rpapb1l = {
  label: "APB Response",
  starting: true,
  url: "rp101m",
  pageLabel: "APB Response",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "File Name", star: false }),
    ...controls.oc({ tab: "filter", name: "apb_file_code", width: "col-sm-2", c: "APBFile", fastpath: "apb_files" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "apb_file_display" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "APB Response",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    textReportProps: {
      'APB Response': {
        filetype: 'apb',
        format: {},
        separator: ""
      },
    },
    displayColumns: [
      {
        Header: "Data",
        accessor: "data",
      }
    ]
  }
};

export default rpapb1l;